// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraPanel } from './TerceraPanel';
import TerceraAutoHidePanelTemplate from '@front/templates/TerceraAutoHidePanelTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraAutoHidePanel extends TerceraPanel {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraAutoHidePanel;
    }
    oncomplete() {
        this.onMoreButtonClick = this.onMoreButtonClick.bind(this);
        super.oncomplete();
        this.subscribe();
    }
    dispose() {
        this.unsubscribe();
        super.dispose();
    }
    subscribe() {
        this._observer = new ResizeObserver(() => {
            const hiddenElementsCountExcludingSeparators = this.getHiddenElementsCountExcludingSeparators();
            void this.set('isShowMoreButton', hiddenElementsCountExcludingSeparators > 0);
        });
        const container = super.find('.auto-hide-panel-container');
        if (!isNullOrUndefined(container)) {
            this._observer.observe(container);
        }
        this.on('onMoreButtonClicked', this.onMoreButtonClick);
    }
    unsubscribe() {
        const container = this.find('.auto-hide-panel-container');
        if (!isNullOrUndefined(container)) {
            this._observer.unobserve(container);
        }
        this.off('onMoreButtonClicked', this.onMoreButtonClick);
    }
    onMoreButtonClick() {
        const contextMenuItems = this.getContextMenuItemsFromHiddenElements();
        const rect = this.findAll('.terceraButton.js-more-button')[0].getBoundingClientRect();
        void this.set('isAutoHideMenuOpen', true);
        showContextMenu({
            x: rect.left,
            y: rect.bottom,
            items: contextMenuItems,
            functions: {
                closeCallback: () => {
                    void this.set('isAutoHideMenuOpen', false);
                }
            }
        });
    }
    getHiddenElements() {
        const hiddenElements = [];
        const container = this.find('.auto-hide-panel-container');
        if (isNullOrUndefined(container)) {
            return hiddenElements;
        }
        for (let i = 0; i < container.children.length; i++) {
            const child = container.children[i];
            if (child.offsetTop > container.offsetHeight + container.offsetTop) {
                hiddenElements.push(child);
            }
        }
        return hiddenElements;
    }
    getContextMenuItemsFromHiddenElements() {
        return this.getHiddenElements()
            .map((element) => ControlsUtils.getRactiveFromHTMLElement(element))
            .filter((component) => !isNullOrUndefined(component === null || component === void 0 ? void 0 : component.getContextMenuItem))
            .map((component) => component.getContextMenuItem())
            .filter((item) => !isNullOrUndefined(item))
            .map((item) => {
            return item;
        });
    }
    getHiddenElementsCountExcludingSeparators() {
        const contextMenuItems = this.getContextMenuItemsFromHiddenElements();
        const filteredItems = contextMenuItems.filter((item) => item.type !== NewContextMenuItemType.Separator);
        return filteredItems.length;
    }
}
TerceraPanel.extendWith(TerceraAutoHidePanel, {
    template: TerceraAutoHidePanelTemplate,
    data: function () {
        return {
            isShowMoreButton: false,
            isAutoHideMenuOpen: false
        };
    }
});
